<template>
    <Toast position="top-center" />
    <div
        class="surface-0 align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden painel"
    >
        <div class="grid justify-content-center p-2 lg:p-0 mt-5">
            <!--<div class="col-12 xl:col-3">-->
            <div class="col-12 md:col-6 xl:col-4">
                <div class="h-full w-full m-0 py-8 px-4">
                    <div class="h-full w-full m-0 py-7 px-4 shadow-3 pnl-form">
                        <div class="text-center mb-5">
                            <h3 class="title"><b>TRANSPARÊNCIA PÚBLICA</b></h3>
                            <h5 class="subtitle">
                                <b>SISTEMA ESTADUAL DE REGULAÇÃO</b>
                            </h5>
                            <div
                                v-if="environment === 'development'"
                                class="user-badge status-false"
                            >
                                AMBIENTE DE DESENVOLVIMENTO
                            </div>
                            <div
                                v-else-if="environment === 'staging'"
                                class="user-badge status-staging"
                            >
                                AMBIENTE DE HOMOLOGAÇÃO
                            </div>
                            <div
                                v-else-if="environment === 'training'"
                                class="user-badge status-training"
                            >
                                AMBIENTE DE TREINAMENTO
                            </div>
                        </div>
                        <div class="text-center mb-2">
                            <img
                                alt="logo"
                                src="../../public/images/sespa/brasaoSespa.svg"
                                height="90"
                                class="logo-responsive"
                            />
                        </div>
                        <div class="flex flex-column md:flex-row">
                            <div
                                class="w-full flex flex-column align-items-center justify-content-center gap-3 py-1"
                            >
                                <form
                                    @submit.prevent="findByParams"
                                    class="col-12"
                                >
                                    <div class="md:w-10 mx-auto imputs">
                                        <InputText
                                            id="nome"
                                            v-model="request.nomePaciente"
                                            type="text"
                                            class="w-full mt-1 mb-2"
                                            placeholder="Digite o NOME do paciente."
                                            style="padding: 1rem"
                                            required
                                        />
                                        <InputMask
                                            id="cpf"
                                            v-model="request.cpfPaciente"
                                            type="text"
                                            mask="999.999.999-99"
                                            class="w-full mt-1 mb-2"
                                            placeholder="Digite o CPF do paciente."
                                            style="padding: 1rem"
                                        />
                                        <InputText
                                            id="dtNascimento"
                                            v-model="request.dataNascimento"
                                            type="text"
                                            class="w-full mt-1 mb-2"
                                            placeholder="Digite a DATA DE NASCIMENTO."
                                            style="padding: 1rem"
                                            @input="mascararDataNascimento"
                                            maxlength="10"
                                        />
                                        <div
                                            class="flex align-items-center justify-content-between mb-1"
                                        ></div>
                                        <Button
                                            label="Pesquisar"
                                            class="w-full p-3 text-xl"
                                            :icon="defaultIcon"
                                            :disabled="disabled"
                                            type="submit"
                                            autofocus
                                        ></Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="layout-footer fix">
        <span class="footer-text"
            >&copy; Todos os Direitos. Coordenação de Tecnologia e Informática
            em Saúde - CTIS. <br />
            Tva. Lomas Valentinas, 2190, Bairro Marco, CEP: 66093-677, Belém,
            Pará Contato: +55, 91 4006-4399 | 4006-4328 |
            <b>www.saude.pa.gov.br</b>
        </span>
    </div>

    <!--MODAL PACIENTE-->
    <dialog-paciente-view :pacienteSelected="paciente" />
    <!--FIM MODAL PACIENTE-->
</template>

<script>
import AuthService from "../service/auth/auth_service";
import PacienteService from "../service/paciente/paciente_service";
import Paciente from "../models/paciente";
import DialogPacienteView from "./components/dialog-paciente-view.vue";

export default {
    components: { DialogPacienteView },
    data() {
        return {
            authService: new AuthService(),
            pacienteService: new PacienteService(),
            paciente: new Paciente(),
            // NORMALIZE: use '' para campos de input (evita comportamento estranho nos componentes)
            request: {
                nomePaciente: "",
                cpfPaciente: "",
                dataNascimento: "",
            },
            disabled: false,
            defaultIcon: "pi pi-sign-in",
        };
    },
    created() {
        this.isTokenExpiredRenovation();
    },
    computed: {
        environment() {
            return process.env.VUE_APP_ENV;
        },
    },
    methods: {
        validarCampos() {
            if (!this.request.nomePaciente) {
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Nome é obrigatório.",
                    life: 5000,
                });
                return false;
            }

            if (!this.request.cpfPaciente && !this.request.dataNascimento) {
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Informe CPF ou Data de Nascimento.",
                    life: 5000,
                });
                return false;
            }

            return true;
        },

        findByParams() {
            if (!this.validarCampos()) return;

            this.disabled = true;
            this.defaultIcon = "pi pi-spin pi-spinner";
            this.isTokenExpiredRenovation();

            const req = {
                nomePaciente: this.request.nomePaciente,
                cpfPaciente: this.request.cpfPaciente,
                dataNascimento: this.formatarData(this.request.dataNascimento),
            };

            this.pacienteService
                .findByPaciente(req)
                .then((data) => {
                    this.paciente = data;

                    if (!this.paciente || this.paciente.length === 0) {
                        this.$toast.add({
                            severity: "info",
                            summary: "Informativo",
                            detail: "Nenhuma informação encontrada.",
                            life: 12000,
                        });
                    } else {
                        this.$store.state.views.paciente.dialogPacienteView = true;
                    }
                })
                .catch((err) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Erro",
                        detail:
                            err.response?.data?.mensagem ||
                            "Serviço indisponível. Tente novamente.",
                        life: 12000,
                    });
                })
                .finally(() => this.resetButton());
        },
        formatarData(data) {
            if (!data) return "";
            const partes = data.split("/");
            if (partes.length !== 3) return "";

            const [dia, mes, ano] = partes;

            // Validação simples
            if (ano.length !== 4) return "";

            return `${ano}-${mes}-${dia}`;
        },
        applyLightThemeForLogin() {
            const themeLink = document.getElementById("theme-link");
            themeLink.href = `themes/bootstrap4-light-blue/theme.css`;
            document.body.classList.remove("dark-mode");
        },
        isTokenExpiredRenovation() {
            if (this.authService.isTokenExpired()) {
                this.authService.clearAccessToken();
                this.authService
                    .login()
                    .then()
                    .catch((response) => {
                        if (response.code === "ERR_NETWORK") {
                            this.$toast.add({
                                severity: "error",
                                summary: "Importante.",
                                detail: "Erro: Não foi possível estabelecer comunicação com o serviço.",
                                life: 12000,
                            });
                        } else {
                            this.$toast.add({
                                severity: "error",
                                summary: "Importante.",
                                detail: "Ops! Não conseguimos se conectar ao serviço. Tente novamente em instantes.",
                                life: 12000,
                            });
                        }
                    });
            } else {
                this.disabled = false;
            }
        },
        resetButton() {
            this.disabled = false;
            this.defaultIcon = "pi pi-sign-in";
        },
        mascararDataNascimento(event) {
            let value = event.target.value;

            // Remove tudo que não for número
            value = value.replace(/\D/g, "");

            // Aplica a máscara dd/mm/yyyy
            if (value.length > 2) {
                value = value.replace(/(\d{2})(\d)/, "$1/$2");
            }
            if (value.length > 5) {
                value = value.replace(/(\d{2})\/(\d{2})(\d)/, "$1/$2/$3");
            }

            // Limita no máximo 10 caracteres (dd/mm/yyyy)
            value = value.substring(0, 10);

            this.request.dataNascimento = value;
        },
    },
};
</script>

<style lang="scss" scoped>
@import url("../App.scss");
html,
body {
    /* Gradiente de branco para verde claro */
    background: linear-gradient(to bottom right, #ffffff, #1e5f2e);

    /* Configurações de UX */
    min-height: 100vh;
    margin: 0;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%; /* Garante que o body ocupe a altura total da tela */
    margin: 0; /* Remove margens padrão do body */
}
.grid {
    display: flex;
    justify-content: center;
    align-items: flex-start; /* Garante que o conteúdo comece do topo */
    height: 100%; /* Permite que a grid ocupe toda a altura */
}
.fix {
    bottom: 0;
    position: fixed;
    width: 100%;
    text-align: center;
}
.layout-footer {
    background-color: #dddddd;
    box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    height: auto; /* Permite que o footer ajuste sua altura automaticamente */
    padding: 10px 0; /* Adiciona algum espaço ao redor do texto */
    transition: transform 0.3s ease, padding 0.3s ease; /* Anima a descida */
}
.painel {
    height: 98vh;
    background-image: url("../../public/images/sespa/fundo2.png");
    background-repeat: no-repeat;
    background-size: 105% 100%;
    padding: 0;
    margin: 0;
}
.pnl-form {
    background-color: #ffffff;
    background-image: radial-gradient(#f8f8f8, #ffffff);
    box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    border-radius: 5px;
    transition: transform 0.3s ease, padding 0.3s ease; /* Anima as mudanças */
    margin-bottom: 50px; /* Para criar espaço entre o formulário e o footer */
}
.font-label {
    font-weight: 500;
}
.footer-text {
    font-size: 16px; /* Tamanho padrão */
    text-align: center; /* Centraliza o texto do footer */
}
@media (max-width: 768px) {
    .footer-text {
        font-size: 14px; /* Tamanho para telas pequenas */
    }
    .logo-responsive {
        max-width: 255px;
    }
    .pnl-form {
        margin-bottom: 100px; /* dá mais respiro pro footer */
        transform: none; /* remove o deslocamento vertical */
    }
    .title {
        font-size: 21px;
    }
    .subtitle {
        font-size: 14px;
    }
    .text-xl {
        font-size: 1.5rem; /* Diminuindo o tamanho da fonte */
    }

    .font-medium {
        font-size: 0.9rem; /* Diminuindo o tamanho da fonte para links */
    }
    .pnl-form {
        transform: none; /* remove deslocamento forçado */
        margin: 2rem 0 8rem 0; /* espaçamento natural */
    }
    h2.title {
        margin-top: 0.5rem;
        font-size: 1.25rem;
    }
}
@media (max-width: 480px) {
    .footer-text {
        font-size: 12px; /* Tamanho para telas extra pequenas */
    }
    h2 {
        font-size: 1.5rem; /* Ajusta o tamanho do título */
    }
    .title {
        font-size: 21px;
    }
    .subtitle {
        font-size: 14px;
    }
    .text-xl {
        font-size: 1.25rem; /* Diminuindo ainda mais o tamanho da fonte */
    }

    .font-medium {
        font-size: 0.9rem; /* Diminuindo ainda mais o tamanho da fonte para links */
    }

    .pnl-form {
        transform: translateY(
            -80px
        ); /* Move mais para cima em telas muito pequenas */
        padding: 1rem; /* Ajusta o padding para melhor visualização */
        margin-bottom: 100px; /* Aumenta ainda mais o espaço em telas menores */
    }
}
@media (max-width: 400px) {
    .layout-footer {
        /*position: relative;*/
    }
    .pnl-form {
        transform: translateY(-135px); /* Mantém o painel elevado */
        padding: 1rem; /* Ajusta o padding para melhor visualização */
        margin-bottom: 150px; /* Aumenta ainda mais o espaço em telas menores */
    }
    .title {
        font-size: 21px;
    }
    .subtitle {
        font-size: 14px;
    }
    .text-xl {
        font-size: 1rem; /* Diminui o tamanho da fonte para títulos */
    }
    h2 {
        font-size: 0.9rem; /* Ajusta o tamanho do título */
        margin-top: -50px; /* Ajuste o valor conforme necessário para subir o título */
    }
    .imputs {
        margin-top: -20px;
        margin-bottom: 20px;
    }

    .user-badge {
        margin-top: -10px; /* Ajuste o valor conforme necessário para subir o ambiente */
        font-size: 0.4rem;
    }

    .font-medium {
        font-size: 0.85rem; /* Reduz o tamanho da fonte para links */
    }

    .font-label {
        font-size: 0.1;
    }

    .footer-text {
        font-size: 10px; /* Reduz ainda mais o tamanho do texto do rodapé */
    }
}
/* Ajuste para notebooks 1366x768 */
@media screen and (max-width: 1400px) and (min-height: 700px) {
    .painel {
        background-size: cover !important;
        background-position: center !important;
    }

    /* Aumenta o tamanho do painel do formulário */
    .col-12.xl\:col-3 {
        max-width: 400px !important;
    }

    .pnl-form {
        padding: 2rem !important;
        margin-top: 1rem !important;
        margin-bottom: 6rem !important; /* evita colar no footer */
    }
    .footer-text {
        font-size: 14px;
    }
}
</style>
